module.exports = __webpack_public_path__ + "assets/img/news (36).b77f1e3c.png";